import React, { ReactNode, FunctionComponent } from 'react'
import { Text, Skeleton, Divider } from '@afterpaytouch/core'

interface OrderSummaryLineProps {
  item: {
    label: ReactNode
    value: ReactNode
    sublabel?: ReactNode
  }
  isLoading?: boolean
  testNameSpace?: string
  show?: boolean
  divider?: boolean
}

export const OrderSummaryLine: FunctionComponent<OrderSummaryLineProps> = ({ item, isLoading = false, testNameSpace = '', show = true, divider = true }) =>
  show ? (
    <div
      className='relative'
      {...(testNameSpace.length > 0 && {
        'data-testid': `order-summary-${testNameSpace}-summary-row`,
      })}
    >
      <div className='relative mt-4 flex items-center'>
        <div className='mr-4 flex-1'>
          <Text renderAs='span' bold size='M'>
            {item?.label}
          </Text>
        </div>
        <div className='flex'>
          <Text renderAs='span' size='M'>
            {item?.value}
          </Text>
        </div>
      </div>
      {Boolean(item?.sublabel) && item?.sublabel}
      {isLoading && <Skeleton />}
      {divider && <Divider kind='Hairline' />}
    </div>
  ) : null
